import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Avatar from "@material-ui/core/Avatar";
import imgAvatar from "../../../../../assets/images/profile.png";
import { colors } from "../../../../../assets/styles";
import Items from "./Items";
import "./styles/drawer.css";
import {
  Container,
  Header,
  HeaderItem,
  HeaderTitle,
  HeaderLevel,
} from "./style";

const useStyles = makeStyles((theme) => ({
  list: {
    width: 250,
    height: "100%",
  },
  dark: {
    backgroundColor: colors.colorDarkOne,
  },
  fullList: {
    width: "auto",
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  verticalAlignSuper: {
    verticalAlign: "super",
  },
  name: {
    fontSize: "13px",
  },
  level: {
    fontSize: "10px",
    color: "#5d5d5d",
  },
}));

const Drawer = ({ drawer, drawerChange, position, user, theme }) => {
  const classes = useStyles();

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    drawerChange(open);
  };

  return (
    <React.Fragment>
      <SwipeableDrawer
        anchor={position}
        open={drawer}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <Container
          className={clsx(
            classes.list,
            {
              [classes.fullList]: position === "top" || position === "bottom",
            },
            theme.isDarkTheme && classes.dark
          )}
          role="presentation"
          onKeyDown={toggleDrawer(false)}
        >
          <Header className="mr-3 mt-3 mb-1 text-right">
            <Avatar
              alt="Remy Sharp"
              src={imgAvatar}
              className={`${classes.large} d-inline-block`}
            />
            <HeaderItem
              className={`d-inline-block ${classes.verticalAlignSuper}`}
            >
              {user?.token ? (
                <>
                  <HeaderTitle
                    className={`d-block mr-3 mt-2 ${classes.name}`}
                    theme={theme}
                  >
                    {user?.data?.name} {user?.data?.family}
                  </HeaderTitle>
                  <HeaderLevel className={`d-block mr-3 mt-2 ${classes.level}`}>
                    مشتری
                  </HeaderLevel>
                </>
              ) : (
                <>
                  <HeaderTitle
                    className={`d-block mr-3 mt-2 ${classes.name}`}
                    theme={theme}
                  >
                    مهمان
                  </HeaderTitle>
                  <HeaderLevel className={`d-block mr-3 mt-2 ${classes.level}`}>
                    مشتری
                  </HeaderLevel>
                </>
              )}
            </HeaderItem>
          </Header>
          <Items drawerChange={drawerChange} />
        </Container>
      </SwipeableDrawer>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Drawer);
